import { InView } from 'react-intersection-observer';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

import useDevice from '../../hooks/useDevice';

import './index.scss';

const Animate = props => {
    const {
        fit,
        children,
        className,
        delay = 0,
        animate = true,
        infinite = false,
        threshold = 0.2,
        forceAnimate = false,
        animation = 'fadeInUp',
    } = props;

    const { isMobile } = useDevice();

    return animate ? (
        <InView
            triggerOnce={!infinite}
            threshold={isMobile ? 0 : threshold}
        >
            {({ inView, ref }) => (
                <div
                    ref={ref}
                    className={classnames(
                        `animated-holder`,
                        `a-${animation}`,
                        className,
                        {
                            fit,
                            'animate': forceAnimate || inView,
                        }
                    )}
                    style={{
                        animationDelay: `${delay}ms`,
                    }}
                >
                    {children}
                </div>
            )}
        </InView>
    ) : (
        children
    );
};

Animate.propTypes = {
    fit: PropTypes.bool,
    delay: PropTypes.number,
    animate: PropTypes.bool,
    children: PropTypes.node,
    animation: PropTypes.oneOf([
        'fadeInUp',
        'fadeIn',
        'bounceIn',
    ]),
    infinite: PropTypes.bool,
    threshold: PropTypes.number,
    className: PropTypes.string,
    forceAnimate: PropTypes.bool
};

export default Animate;
